// extracted by mini-css-extract-plugin
module.exports = {"submit":"discard-modal_submit__dcbb8"};